import useWidth from '@components/Hooks/useWidth';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { Play } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';
import { useTranslation } from '../../../../../translation/TranslationContext';

interface LiveShopButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const LiveShopButton = ({ isActive, onClick }: LiveShopButtonProps) => {
  const { translate } = useTranslation();
  const { smallWidth } = useWidth();
  const label = translate(LangEnum.CATALOG_LIVE_SHOP_BUTTON);

  if (smallWidth) {
    return (
      <IconButton
        icon={Play}
        color="secondary"
        shape="round"
        isActive={isActive}
        ariaLabel={label}
        testId={CatalogProductsTestIds.LIVE_SHOP_BUTTON}
        onClick={onClick}
      />
    );
  }

  return (
    <Button
      variant="contained"
      color="secondary"
      size="medium"
      isActive={isActive}
      testId={CatalogProductsTestIds.LIVE_SHOP_BUTTON}
      onClick={onClick}
      startIcon={<Icon icon={Play} />}
    >
      {label}
    </Button>
  );
};

export default LiveShopButton;
